import React from 'react';
import { Card } from 'react-bootstrap';
import { FileExcel, FileExcelFill } from 'react-bootstrap-icons';

interface Props {
  t: any,
  countsState: any,
  counts: Array<string>,
  showCounts: boolean,
  openExportModal: ( source?: string, table?: boolean, title?: string, status?: Number ) => void,
  toggleCounts: any
}

const PurchasesTopCard = ( props: Props) => {
  return ( 
          <Card>
            <Card.Body>
              <b>
                {props.t('TOTAL').toUpperCase()}
              </b>
              : {props.countsState.total}
              <div>
                <small onClick={() => props.openExportModal(undefined, false, props.t('DOWNLOAD_REPORT'))}
                  className='cursor'><FileExcelFill color='green' />
                  {props.t('DOWNLOAD_REPORT')}
                </small>
                <small style={{ marginLeft: '1em' }}
                  onClick={() => props.openExportModal(undefined, true, props.t('DOWNLOAD_TABLE'))}
                  className='cursor'><FileExcel color='green' />
                  {props.t('DOWNLOAD_TABLE')}
                </small>
                <small style={{ marginLeft: '1em' }}
                  onClick={() => props.openExportModal(undefined, true, props.t('DOWNLOAD_INVOICE'), 1)}
                  className='cursor'><FileExcel color='green' />
                  {props.t('DOWNLOAD_INVOICE')}
                </small>
                <small style={{ marginLeft: '1em' }}
                  onClick={() => props.openExportModal(undefined, true, props.t('DOWNLOAD_SENSORS_LICENSES_REPORT'), 1)}
                  className='cursor'><FileExcel color='green' />
                  {props.t('DOWNLOAD_SENSORS_LICENSES_REPORT')}
                </small>
              </div>
              {
                props.counts.length > 0 &&
                <>
                  <span
                    style={{ float: 'right', cursor: 'pointer', fontSize: '0.8em' }}
                    onClick={props.toggleCounts}
                  >
                    {props.t(props.showCounts ? 'HIDE_DETAILS' : 'SHOW_DETAILS')}
                  </span>
                  {
                    props.showCounts &&
                    <table style={{ fontSize: '0.8em' }}>
                      <tbody>
                        {props.counts.map((key: string) => <tr key={key}>
                          <th>
                            {key}:
                          </th>
                          <td>
                            {props.countsState.sources[key]}
                          </td>
                          <td className='cursor' onClick={() => props.openExportModal(key, false, props.t('DOWNLOAD_REPORT'))}>
                            <FileExcelFill color='green' />
                            {props.t('DOWNLOAD_REPORT')}
                          </td>
                          <td className='cursor' onClick={() => props.openExportModal(key, true, props.t('DOWNLOAD_REPORT'))}>
                            <FileExcel color='green' />
                            {props.t('DOWNLOAD_TABLE')}
                          </td>
                          <td className='cursor' onClick={() => props.openExportModal(key, true, props.t('DONLOAD_INVOICE'), 1)}>
                            <FileExcel color='green' />
                            {props.t('DOWNLOAD_INVOICE')}
                          </td>
                          <td className='cursor' onClick={() => {
                            props.openExportModal(key, true, props.t('DOWNLOAD_SENSORS_LICENSES_REPORT'), 1);
                          }}>
                            <FileExcel color='green' />
                            {props.t('DOWNLOAD_SENSORS_LICENSES_REPORT')}
                          </td>
                        </tr>)}
                      </tbody>
                    </table>
                  }
                </>
              }
            </Card.Body>
          </Card>
  );
};

export default PurchasesTopCard;